import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MarketDataService {
  private marketDataSubject = new BehaviorSubject<any>(null);
  marketData$ = this.marketDataSubject.asObservable();

  updateMarketData(data: any) {
    this.marketDataSubject.next(data);
  }
}